module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mark of Evil ")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0005-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#nc1",
      "id": "cn1"
    }
  }, [_c('b', [_vm._v("ONE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('b', [_vm._v("IN THE FUTURE ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_c('b', [_vm._v("Athens, Greece ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Ethan March had just confronted the horror once again. He now struggled to steady himself and to clear his mind after seeing the hideous face. He murmured to himself, lips barely moving, as he spoke the two words that seemed to explain everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The beast.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A lightning-fast shiver shot down his spine, like an aftershock following an earthquake. One thing he knew for certain: he had not dreamed it and it wasn’t just some nightmare; he was sure of that. Just more evidence, he thought to himself, that the final reckoning approached.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan had spent the previous night sleeping up on the flat, tiled roof of his apartment building. The air-conditioning inside the "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v(" building didn’t work and it was cooler up there. It was likely the rioting across the city and all the fires had caused the electrical failures everywhere. Economic desperation had wrestled Greece into an economic choke hold, just like the rest of the world. And the masses were getting restless.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("At the first glimmer of dawn that morning he had wakened on the rooftop, stretched, rubbed the sleep away from his face, and said his morning prayers. The sun was just breaking over the mountains, spreading its burning light across the miles of whitewashed office buildings and apartments crammed into the Greek capital. It was then—with his eyes wide open—the same vision had appeared to him, just as it had so many times before. Ethan was convinced it was a message from God. He didn’t care what other people thought. Although the truth was he had told very few others about what he saw in those moments. He couldn’t afford to. He also understood that in some strange way the visions were for his benefit, even though they unsettled him deeply, down to his gut.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Each time the sequence was the same: the image of a handsome man would appear to Ethan out of nowhere. But those features would linger only momentarily and would quickly disappear like a morning fog evaporating in the sun. And then, suddenly, in one great, sickening jolt, there would come another face—a repulsive, red-eyed creature. A moment later and it would all be over. The vision would leave Ethan drenched with a sense of dread and wondering why, out of everyone in the human race, he’d been chosen to encounter the image of that grotesque creature, over and over again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan was still up on the flat rooftop, and now his eyes searched the four corners around him. He had to be ready for nasty, unannounced visitors, like the violent men who were probably at that very minute scouring the city for him. Tracking him down.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("But today he was expecting his buddy Jimmy Louder, who was supposed to arrive any moment now. Louder was one of the most ")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v(" trusted men in Ethan’s Remnant group—the underground network struggling to survive in this new order of things. Like Ethan, Louder had once been an air force pilot, but he was several years older. He had a laid-back manner, but underneath there was a reserve of toughness, something that had come in handy during his confinement in a North Korean prison camp. Although Louder and Ethan didn’t focus on physical survival—their mission was bigger than that—it was still a necessity, especially for Ethan, who was at the top of the Most Wanted list of the Global Alliance.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("From his position up on the roof, Ethan could now hear the sirens wailing across the city and see smoke spiraling up from half-a-dozen fires set by vandals, rioters, or looters. This was life as usual. He knew similar scenes were happening in every other major city on the planet. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With no sign of Louder, Ethan decided to make use of the time. He yanked up the bottom edge of his sleeveless T-shirt to wipe the sweat off his face, cracked the stiffness out of his nineteen-inch neck, and rose to his feet, shaking his muscular arms to loosen them up. Then he dropped down for fifty rapid-fire push-ups. Then fifty sit-ups. Then leg raises, followed by an explosive volley of running in place. He must have been shaking the roof, because someone in the apartment below began screaming out the window. Ethan understood a little Greek and knew the man downstairs was yelling for him to stop. He was shouting a few other choice things too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan smiled and called back an apology. "), _c('i', [_vm._v("“Sygnomi!”")]), _vm._v(" He grabbed his canvas rucksack, which was filled with fifty pounds of bricks, and prepared for his daily routine. For the last two years he had been forced to live his life like an endless series of stunts on a movie lot—scampering down the sides of apartment buildings, leaping from rooftops, and jumping out of moving cars—just to stay one step ahead of the Global Alliance agents who pursued him. That meant every day was a training day.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Strapping the heavy rucksack to his back, he sauntered over to ")]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" the edge of the three-story building where a four-foot black, wrought-iron fence surrounded the rooftop. A rope had already been cinched to it and hung over the side until it nearly reached the street level. He climbed over the fence and quickly rappelled down the rope. Then came the hard part—with a heave, he scampered back up the rope to the rooftop with the pack full of bricks still strapped onto his back.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("While he caught his breath on the roof, a voice brought him out of his thoughts. “I figured I’d find you up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan snapped around. He relaxed when he recognized the thin frame of Jimmy Louder with his reddish hair receding in a widow’s peak at the temples.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Always pushing yourself physically,” Louder said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan shrugged and smiled. “Force of habit, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Going all the way back to your Triple-A baseball training, I suppose? Nearly making the pros—yeah, that always impressed me, by the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, it didn’t impress the pitching coach much,” Ethan shot back with a smirk. “I had a pretty good fastball. But about as much control over the ball as my mom had over her tomcat. And then there were those other problems I had with the game . . . So, next stop, the United States Air Force.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder had a glint of admiration in his face. “And all of that special-ops training they put you through. Now, me? I was just one of those ol’ run-of-the-mill fighter pilots who only got the basic survival camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Which came in handy, I bet, when you got shot down on the wrong side of the DMZ.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure. For the four days I was on the run. Until I ran smack into a North Korean patrol. Oh well. Water under the bridge. And God was good. Two years later He sent Joshua Jordan and the rest of you guys to get me out.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("Ethan still struggled over that. He always felt a sting of regret that ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v(" he didn’t really do a lick of work on that rescue mission. It had all been God and Josh Jordan as far as he was concerned. Oh yes, and the pretty, dark-eyed Rivka. She had been in on it too, big-time. How could he forget her?")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“The minute I noticed your new location on the encrypted Remnant GPS,” Louder continued, “I wondered what happened to that cheap hotel room where you were living before—the one on the western end of the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“High-crime area,” Ethan said with a wink. “Bad neighborhood.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder chuckled. “Since when are you afraid of a little violence and mayhem?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Actually,” Ethan explained, “some agents from the Global Alliance’s security police showed up one day and started asking the landlord about me. I had to split in a hurry. So I found a room here in the Plaka district. It turns out this landlady’s one of us. So what’s new with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder quickly surveyed the rooftop. They were still alone. “Two things. First, on a personal note”—he broke into a grin—“I ran into Rivka a few days ago at a safe house in Jerusalem. She was traveling through on her way back to Hong Kong. She said to say hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan’s face brightened slightly. “Oh? Did she say anything else?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Only that she would really like to see you soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan shrugged. “Well, she knows the encrypted underground number. She can locate me that way anytime she likes. In fact, she could have done that a year ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder snickered. “Do I sense that you’ve got some feelings on that subject?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan waved the comment off. “What’s the second thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder sobered. “Speaking of the Global Alliance, I think I was tailed today. Two rough-looking guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was something Ethan didn’t want to hear. He could feel his jaw tensing. “Did you lose them?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, about a block from here. They didn’t look like Global Alliance police. More like bounty hunters. Probably sniffing after the reward money the Alliance is offering.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wondered when the Alliance was going to raise the bounty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, on you they have. Big money. But for the capture of little ol’ me,” Louder said, “they’re just offering dresser change.” He gave out a fake whimper. “My male ego is still aching about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan managed a grin. But silently he mulled over the bounty hunter issue. He hoped Louder had lost the guys tailing him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He shook it off and changed the subject. “All right, on the subject of an underground barter payment system, where are we on that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ve been in contact with the black market guy. His name is Gikas. A local Greek. He’s the Athens point person for Mr. Big.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Jo Li?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Right. I’ve already set up the introductory meeting with Gikas.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where is Jo Li now?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t know. But we may find out shortly. You and I have a meeting with Gikas up at the Acropolis, like, right now. That’s why I came by to pick you up. Sorry about the short notice. If he clears us for the next step, then we get a meeting directly with Jo Li.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good,” Ethan said, snatching his short-sleeved shirt off the roof and slipping it on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just one thing,” Louder said. There was caution in his voice. “We just don’t know a lot about Jo Li’s operation. I’ve only heard rumors. We have to be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure. But those of us in the Remnant who refused to get laser imprinted with the BIDTag identification don’t have any choice,” Ethan shot back. “Ever since the Alliance linked the universal monetary system to everybody’s BIDTag via the web, we’ve been stuck. I’m hoping Jo Li’s system will be our ticket to an alternate method to buy and sell.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder smiled as he watched Ethan launch into one of his favorite subjects.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“If we fail in this,” Ethan continued, “our people won’t eat. Won’t be able to pay for housing. And we’ll be strapped for communications money to deliver the truth to a world on the verge of imploding. And then there’s our field operations budget. Without that, how are we going to protect God’s people from the evil empire? This is a ‘Moses at the Red Sea’ moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I thought you said you weren’t called to be a preacher,” Jimmy cracked with a sly smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan shrugged it off. “Okay, so I guess I’m cranked up this morning.” He looked out beyond the rooftops and up to the ancient ruins on the top of the hill in the distance. He studied the columns of the ancient Acropolis from his position on the rooftop, and then he asked a question that came out more like an answer. “Most people just don’t think their own civilization will crumble, do they? Josh kept telling me how one day the whole planet would start collapsing into chaos, right before God wraps up history once and for all. Brings Christ back to establish His kingdom. Like an idiot, I didn’t take it seriously back then. But Josh was right. He was right about a lot of things.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder studied him. “You miss him, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I miss all of them,” Ethan shot back. “The whole Jordan family. Josh. And Abby too. Boy, she really sized me up when she first noticed I was interested in her daughter!” He laughed. “And I miss her too. Deb Jordan, I mean. I know now why it never would have worked between the two of us, though I didn’t have a clue at the time. And I miss Cal, of course. We ended up like brothers. But right now I know that none of them are looking back. No regrets. And meanwhile you and I, because we dragged our feet in making a decision about Jesus, ended up being left behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder bobbed his head. “At least we’re on track now.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("Just then Ethan heard a sound, as if someone approached. He was instantly on the alert, like a hunting dog. The noise came from the far end of the rooftop where it was accessed by a single door ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v(" set into a copula. Ethan narrowed his eyes and pointed to the door. “When you came up to the roof, was anyone hanging around in the stairwell?”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before Ethan could reply, the door burst open and two men rushed out onto the rooftop. In the lead came a bounty hunter sporting a Mohawk and a sleeveless shirt that revealed tattoos running down both arms. He was followed by a tall, lanky man with his hair tied back in a ponytail who hung back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hold it right there!” the tattooed guy screamed as he stood his ground at the other end of the roof. He pointed a strange-looking gun in their direction. “We’ve got a piece of paper from the Global Alliance. And you know what?” He broke into a big grin. “It’s got both your names on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They had those kinds of papers in Nazi Germany too,” Ethan called back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nice history lesson, Jesus freak,” the man yelled, following up with a string of profanities. “But I didn’t come this far to chat. Wait till the Alliance starts putting the screws to your head,” he said with a laugh. “I wish I could see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan whispered to Louder, “I’m not carrying at the moment. Are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nope,” Louder replied in a hushed voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan sucked in a deep breath and stared at the two tough guys edging cautiously toward them. “Looks like we’ll have to do this the hard way.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d8e4d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 69
// module chunks = 0